import {defineMessages} from 'react-intl';

export default defineMessages({
  chapter: {
    defaultMessage: '{numberOfChapters, plural, one {Chapter} other {Chapters}}',
    id: 'CertificationStatusBox.ProgressIndicator.Chapter',
  }
});
